import React from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import { ExpandLess } from '@mui/icons-material';
import { motion, AnimatePresence } from 'motion/react';
import { MiniPanelProps } from '../../../../types/steps';

interface MiniPanelContainerProps extends MiniPanelProps {
  children: React.ReactNode;
  showExpandButton?: boolean;
}

const MiniPanel: React.FC<MiniPanelContainerProps> = ({
  children,
  isActive,
  onExpand,
  onClose,
  showExpandButton = true
}) => {
  const theme = useTheme();

  return (
    <AnimatePresence>
      {isActive && (
        <Box
          component={motion.div}
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ 
            type: "spring", 
            stiffness: 400, 
            damping: 30,
            duration: 0.3
          }}
          sx={{
            position: 'absolute',
            bottom: '100%',
            left: 0,
            right: 0,
            backgroundColor: theme.palette.background.paper,
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
            boxShadow: theme.shadows[8],
            border: `1px solid ${theme.palette.divider}`,
            borderBottom: 'none',
            padding: '16px',
            paddingBottom: '12px',
            zIndex: 10
          }}
        >
          {/* Expand Button */}
          {showExpandButton && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '12px'
              }}
            >
              <IconButton
                onClick={onExpand}
                size="small"
                sx={{
                  backgroundColor: theme.palette.action.hover,
                  '&:hover': {
                    backgroundColor: theme.palette.action.selected,
                  },
                  width: '32px',
                  height: '32px'
                }}
              >
                <ExpandLess fontSize="small" />
              </IconButton>
            </Box>
          )}

          {/* Panel Content */}
          <Box sx={{ minHeight: '40px' }}>
            {children}
          </Box>
        </Box>
      )}
    </AnimatePresence>
  );
};

export default MiniPanel;
